module.exports = __webpack_public_path__ + "static/media/schedule-impartial.88870d7e.svg";